const CAROUSEL_STRATEGIES = {
  CHANGE_SLIDE: 'CHANGE_SLIDE',
  GET_CURRENT_VALUE: 'GET_CURRENT_VALUE',
  GET_TRANSFORM_OFFSET: 'GET_TRANSFORM_OFFSET',
  GET_NEAREST_SLIDE: 'GET_NEAREST_SLIDE',
};

export default CAROUSEL_STRATEGIES;
